import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/logos/Main/Myceleblogo.png'
import _imports_1 from '../../assets/images/icon-right-white.png'


const _withScopeId = n => (_pushScopeId("data-v-3eabbe3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  title: "celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore",
  src: _imports_0,
  class: "main-logo",
  alt: "white-logo",
  style: {"max-height":"50px"}
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  title: "celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore",
  src: _imports_0,
  class: "white-logo d-none",
  alt: "white-logo",
  style: {"max-height":"50px"}
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "burger-menu" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "top-bar" }),
  /*#__PURE__*/_createElementVNode("span", { class: "middle-bar" }),
  /*#__PURE__*/_createElementVNode("span", { class: "bottom-bar" })
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent"
}
const _hoisted_6 = { class: "nav-item dropdown" }
const _hoisted_7 = { class: "nav-item dropdown" }
const _hoisted_8 = { class: "nav-item dropdown" }
const _hoisted_9 = { class: "nav-item dropdown" }
const _hoisted_10 = { class: "nav-item dropdown" }
const _hoisted_11 = { class: "nav-item dropdown" }
const _hoisted_12 = { class: "nav-item dropdown" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "others-options" }, [
  /*#__PURE__*/_createElementVNode("ul", { class: "d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", {
        title: "MyCelebrity by Digitalentio is a leading celebrity and influencer marketing agency in India.",
        href: "https://wa.me/919113229933",
        target: "_blank",
        rel: "noopener noreferrer",
        class: "default-btn"
      }, [
        /*#__PURE__*/_createTextVNode(" GET A PROPOSAL "),
        /*#__PURE__*/_createElementVNode("img", {
          title: "celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore",
          src: _imports_1,
          alt: "right-chevron"
        })
      ])
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass(['navbar navbar-expand-lg', { sticky: _ctx.isSticky }]),
    id: "navbar"
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(['container', _ctx.mwClass])
    }, [
      _createVNode(_component_router_link, {
        class: "navbar-brand",
        to: "/"
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _hoisted_2
        ]),
        _: 1
      }),
      _createElementVNode("a", {
        title: "MyCelebrity by Digitalentio is a leading celebrity and influencer marketing agency in India.",
        class: "navbar-toggler",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args)))
      }, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("ul", {
          class: _normalizeClass(['navbar-nav', _ctx.className])
        }, [
          _createElementVNode("li", _hoisted_6, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" HOME ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_7, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/services"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" OUR SERVICES ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_8, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/our-team"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" GET YOUR WISH ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_9, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/Client"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" OUR CLIENTS ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_10, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/about-us"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" ABOUT US ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_11, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/success-stories"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" OUR WORK ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_12, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: "/contact-us"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" CONTACT US ")
              ]),
              _: 1
            })
          ])
        ], 2)
      ]),
      _hoisted_13
    ], 2)
  ], 2))
}